import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import {
  CountryStateCityAreaCityField,
  CountryStateCityAreaCountryField,
  CountryStateCityAreaNearByField,
  CountryStateCityAreaStateField,
  CountryStateCityAreaSuburbField,
} from "./widget/CountryStateCityAreaTextfieds";
import Div from "../../../widget/common/ui/Div";
import {
  CountryStateCityAreaContextImport,
  CountryStateCityAreaContextProvider,
} from "../../../provider/country_state_city_area/country_state_city_area/CountryStateCityAreaContextProvider";
import { ButtonSingle } from "../../../widget/common/form/Button";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { routeName as routeNameSearch } from "../../search/SearchScreen";
import { TextBlock } from "../../../widget/common/ui/Text";

const CountryStateCityAreaAlert = (props: { screenName?: string }) => {
  const type: number = ResponsiveDeviceType();
  return (
    <CountryStateCityAreaContextProvider>
      <CountryStateCityAreaAlertBody
        type={type}
        screenName={props.screenName ?? ""}
      />
    </CountryStateCityAreaContextProvider>
  );
};

export default CountryStateCityAreaAlert;

const CountryStateCityAreaAlertBody = (props: {
  type: number;
  screenName?: string;
}) => {
  const screenName: string = props.screenName ?? "";

  const { applySubmitGeo } = CountryStateCityAreaContextImport();

  return (
    <Div className="px-1 px-lg-4">
      <form autoComplete="off">
        {screenName === routeNameSearch && (
          <div className="pb-3 d-flex align-items-center justify-content-between">
            <TextBlock
              fontSize="20_21"
              fontName="bold"
              textColor="theme-label"
            >
              {AppTranslation.text("near_by")}
            </TextBlock>
            <CountryStateCityAreaNearByField />
          </div>
        )}

        <CountryStateCityAreaCountryField />
        <CountryStateCityAreaStateField />
        <CountryStateCityAreaCityField />

        {screenName === routeNameSearch && <CountryStateCityAreaSuburbField />}

        <Div className="pt-4 d-center">
          <ButtonSingle handleClick={() => applySubmitGeo()} width={250}>
            {AppTranslation.text("submit")}
          </ButtonSingle>
        </Div>
      </form>
    </Div>
  );
};
